import { authTypes } from "../actions/auth";

const initialState = {
  isAutoLogout: false,
  isLogin: false,
  isOrgSelectorOpen: false,
  ORG_ADMIN : {
    "alarms": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    },
    "apiDocumentation": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    },
    "assets": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    },
    "devices": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    },
    "Locations": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    },
    "users": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    },
    "organizations": {
        "edit": true,
        "view": true,
        "create": true,
        "delete": true,
        "download": true,
        "configure": true
    }
},
  user: null,
  loading: false,
  error: null,
  currentUser: null,
  ui: {
    notification: {
      isActive: false,
      type: "error",
      message: "",
      description: "",
      style: { backgroundColor: "#d4edda", color: "#155724" },
    },
  }
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case authTypes.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        isOrgSelectorOpen: false,
         ui: {
         ...state.ui,
          notification: {
        ...state.ui.notification,
        isActive: false,
      },
    },
      };
    case authTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isAutoLogout: false,
        isLogin: false,
        loading: false,
        ...action.payload,
      };
      case authTypes.CLEAR_NOTIFICATION:
        return {
          ...state,
          ui: {
            ...state.ui,
            notification: {
              ...state.ui.notification,
              isActive: false,
              message: "",
              description: "",
            },
          },
        };
    case authTypes.LOGIN_FAILURE:
      return {
        ...state,
        isAutoLogout: false,
        isLogin: false,
        loading: false,
        currentUser: null,
        isOrgSelectorOpen: false,
        error: action.payload,
         ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Login failed",
            description: action.payload.replace(/^unauthorized:\s*/, ""), 
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
      };
    case authTypes.WATCH_LOGIN:
      return {
        ...state,
          ui: {
         ...state.ui,
          notification: {
        ...state.ui.notification,
        isActive: false,
      },
    },
      };
    case authTypes.LOGOUT:
      return {
        ...state,
        isAutoLogout: false,
        isLogin: false,
        user: null,
        loading: false,
        isOrgSelectorOpen: false,
        error: null,
        currentUser: null,
      };
    case authTypes.CLEAR_AUTH_ERROR:
      return {
        ...state,
        error: null,
        currentUser: null
      };
    case authTypes.AUTO_LOGOUT:
      return {
        ...state,
        isAutoLogout: action.payload,
        isOrgSelectorOpen: false,
      };
      case authTypes.CHOOSE_USER_ORGANIZATION:
        return {
          ...state,
          isLogin: true,
          user: {
            ...state[action.payload.key],
            ...action.payload
          },
          isOrgSelectorOpen: false,
        };
        case authTypes.UPDATE_AUTH:
        return {
          ...state,
          [action.payload.key]: action.payload.value,
        };
    default:
      return state;
  }
};

export default authReducer;
